import React from 'react';
import withIcon from '../utilities/withIcon';

const IconNoWifi = () => {
  return (
    <g>
      <path d="M6.26 10.216 8 11.956l1.74-1.74a.738.738 0 1 1 1.044 1.044L9.044 13l1.74 1.74a.738.738 0 1 1-1.044 1.044L8 14.044l-1.74 1.74a.738.738 0 1 1-1.044-1.044L6.956 13l-1.74-1.74a.738.738 0 1 1 1.044-1.044zm1.756-6.205a7.694 7.694 0 0 1 5.9 2.75.755.755 0 0 1-.088 1.06.745.745 0 0 1-1.054-.087 6.202 6.202 0 0 0-4.758-2.219c-1.78 0-3.438.754-4.612 2.053a.745.745 0 0 1-1.057.05.755.755 0 0 1-.05-1.062 7.69 7.69 0 0 1 5.72-2.545zm0-4.011c2.98 0 5.768 1.23 7.779 3.362a.755.755 0 0 1-.028 1.063.745.745 0 0 1-1.057-.028 9.17 9.17 0 0 0-6.694-2.893 9.31 9.31 0 0 0-6.728 2.87.745.745 0 0 1-1.057.025.755.755 0 0 1-.024-1.064C2.208 1.231 5.04 0 8.017 0z" />
    </g>
  );
};

export default withIcon(IconNoWifi);
